export default __webpack_public_path__ + "static/media/mar.2987d4ff.svg";